"use client";

import JobDetailContent, { type JobData } from "@/components/Company/JobDetailContent";

const jobData: JobData = {
  title: "Offensive Security Engineer",
  sections: [
    {
      title: "Key Responsibilities",
      items: [
        "Develop sophisticated malware and exploit tools to simulate real-world cyber-attacks against our systems and networks.",
        "Conduct in-depth research to identify new vulnerabilities and develop custom exploits.",
        "Collaborate with the Red Team to plan and execute complex penetration testing and red team engagements.",
        "Create and maintain documentation for developed malware and exploits, including mitigation and defense strategies.",
        "Continuously update and improve attack methodologies to remain ahead of evolving security measures.",
        "Provide technical guidance and support to other team members in exploit development and malware creation.",
        "Analyze and replicate tactics, techniques, and procedures (TTPs) used by real-world adversaries.",
        "Write tools to automate assessment tasks and improve work efficiency.",
      ],
    },
    {
      title: "Required Experience and Skills",
      items: [
        "Minimum 3 years of direct security experience.",
        "Proven experience in offensive security, particularly in malware and exploit development.",
        "Strong programming skills in languages such as C, C++, Python, or Assembly.",
        "Advanced knowledge in internals of Windows or Unix/Linux operating system. You are not required to be an expert in both OS but you have to be an expert in at least one.",
        "Solid understanding of various protocols from the application layer to the Ethernet layer.",
        "Familiar with various network topologies and standards such as LAN/WAN/VPN/Wireless LAN.",
        "Experience with reverse engineering, vulnerability research, and exploit development.",
        "Familiar with SRE tools (IDA, Ghidra, etc) and debugger tools (GDB, Windbg).",
        "Familiarity with common defensive technologies (eg: EDR, Antivirus, IDS, IPS, etc) and how to evade them.",
        "Ability to work both independently and collaboratively in a fast-paced, dynamic environment.",
        "Excellent problem-solving skills and a creative approach to challenging security scenarios.",
      ],
    },
    {
      title: "Benefits",
      items: [
        "Opportunity to work in a cutting-edge security environment and tackle unique challenges.",
        "Collaborative and innovative team committed to professional growth and knowledge sharing.",
        "Access to the latest tools and technologies in offensive security.",
        "Regular training and development opportunities to stay at the forefront of security advancements.",
      ],
    },
    {
      title: "Soft Skills",
      items: [
        "Good command in both Written and Spoken English.",
        "An ability to work under a dynamic environment and remotely.",
        "Good team player.",
        "Able to work under pressure with positive attitude towards the team.",
        "Reliable responsibility.",
        "Must be able to travel abroad.",
      ],
    },
  ],
  closingNote:
    "ECQ firmly believes in Skills and Quality of Work. No certification or degree is required. All candidates are welcomed and will be screened through technical interview. All applications will be treated as strictly confidential. Successful candidate will receive attractive remuneration package. Interested applicants please submit your application and resume with a recent photo either by post or e-mail to the following address.",
  applyEmail: "hr@e-cq.net",
};

export default function OffensiveSecurityEngineerJD() {
  return <JobDetailContent data={jobData} />;
}
